export default "__VITE_ASSET__DeKU54Lj__"